import { render, staticRenderFns } from "./IcoMenu.vue?vue&type=template&id=1ea498ae&"
import script from "./IcoMenu.vue?vue&type=script&lang=js&"
export * from "./IcoMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports